export const API_ENDPOINTS = {
  CHECK: {
    GET: `check`,
  },
  AUTH: {
    REGISTER: `auth/register`,
    LOGIN: `auth/login`,
    FORGOT_PASSWORD: `auth/forgot-password`,
    VERIFY_CODE: `auth/verify-code`,
    RESET_PASSWORD: `auth/reset-password`,
    CHANGE_PASSWORD: `auth/change-password`,
    PASSWORD_STATUS: `auth/password-status`,
    SET_PASSWORD: `auth/set-password`,
    UPDATE: `auth/update`,
    EMAIL_CHANGE: `auth/email-change`,
    EMAIL_CHANGE_CONFIRM: `auth/email-change/confirm`,
    PROFILE: `auth/profile`,
    SESSION: `auth/session`,
    REFRESH: `auth/refresh`,
    LOGOUT: `auth/logout`,
    SETUP_2FA: `auth/setup-2fa`,
    VERIFY_2FA_SETUP: `auth/verify-2fa-setup`,
    DISABLE_2FA: `auth/disable-2fa`,
    STATUS_2FA: `auth/2fa-status`,
    BACKUP_CODES_2FA: `auth/2fa-backup-codes`,
    VERIFY_2FA: `auth/verify-2fa`,
    GOOGLE_LOGIN: `auth/google`,
    GOOGLE_CONFIG: `auth/google/config`,
    GOOGLE_BIRTHDAY: `auth/google/birthday`,
    TELEGRAM_LOGIN: `auth/telegram`,
    TELEGRAM_LINK: `auth/telegram/link`,
    TELEGRAM_UNLINK: `auth/telegram/unlink`,
    TELEGRAM_STATUS: `auth/telegram/status`,
    TELEGRAM_CONFIG: `auth/telegram/config`,
    TELEGRAM_WIDGET_LOGIN: `auth/telegram/widget`,
    TELEGRAM_WIDGET_LINK: `auth/telegram/widget/link`,
    TON_LOGIN: `auth/ton`,
    TON_PAYLOAD: `auth/ton/payload`,
    TON_CONFIG: `auth/ton/config`,
    TON_MANIFEST: `auth/ton/manifest`,
    VERIFY_STATUS: `auth/verify-status`,
    VERIFY_STATUS_SEND: `auth/verify-status/send`,
    VERIFY_STATUS_VERIFY: `auth/verify-status/verify`,
    VERIFY_EMAIL: `auth/verify-email`,
    SEND_VERIFICATION_EMAIL: `auth/send-verification-email`,
    ACCOUNT_STATUS: `auth/account-status`,
    COMPLETE_PROFILE: `auth/complete-profile`,
    GEO: `auth/geo`,
  },
  RESPONSIBLE_GAMING: {
    OVERVIEW: `responsible-gaming`,
    LIMITS: `responsible-gaming/limits`,
    SESSION: `responsible-gaming/session`,
    COOL_OFF: `responsible-gaming/cool-off`,
    SELF_EXCLUSION: `responsible-gaming/self-exclusion`,
    STATEMENT: `responsible-gaming/statement`,
  },
  MARKETING: {
    PREFERENCES: `marketing/preferences`,
    UNSUBSCRIBE: `marketing/unsubscribe`,
    UNSUBSCRIBE_CHECK: `marketing/unsubscribe/check`,
  },
  PUSH: {
    STATUS: `push`,
    SUBSCRIBE: `push/subscribe`,
    UNSUBSCRIBE: `push/unsubscribe`,
    TEST: `push/test`,
  },
  ACCOUNT: {
    CLOSE: `account/close`,
    EXPORT: `account/export`,
  },
  USER_KYC: {
    STATUS: `user-kyc/status`,
    SUBMIT: `user-kyc/submit`,
    UPLOAD: `user-kyc/upload`,
    ADDRESS_SEARCH: `user-kyc/address-search`,
  },
  MEDIA: {
    UPLOAD: `media/upload`,
  },
  IN_HOUSE: {
    PLINKO: {
      ROLL: `in-house/plinko/roll`,
    },
    LIMBO: {
      ROLL: `in-house/limbo/roll`,
    },
    COINFLIP: {
      ROLL: `in-house/coinflip/roll`,
    },
    KENO: {
      ROLL: `in-house/keno/roll`,
    },
    DICE: {
      ROLL: `in-house/dice/roll`,
    },
    DIAMONDS: {
      ROLL: `in-house/diamonds/roll`,
    },
  },
  BALANCE: {
    GET: `balance`,
    CHANGE_CURRENCY: `balance/change-currency`,
    CHANGE_SHOW_CURRENCY: `balance/change-show-currency`,
    WALLETS: `balance/wallets`,
  },
  CURRENCY: {
    GET_OPTIONS: `currency/options`,
    GET_SHOW_OPTIONS: `currency/show-options`,
    GET_WALLET_OPTIONS: `currency/wallet-options`,
    GET_CRYPTO_OPTIONS: `currency/crypto-options`,
  },
  PAYMENT: {
    HISTORY: `payment/history`,
    LEDGER: `payment/ledger`,
    SKY_LEDGER: `payment/sky-ledger`,
    METHODS: `payment/methods`,
    DEPOSIT: `payment/deposit`,
    WITHDRAW: `payment/withdraw`,
    WITHDRAW_FEE: `payment/withdraw-fee`,
    CANCEL_WITHDRAW: (id: string) => `payment/withdraw/${id}/cancel`,
    DEPOSIT_BONUSES: `promotion/deposit-bonuses`,
  },
  // TON crypto gateway. Deposits redirect to the gateway's hosted cashier,
  // so no address or chain amount is ever handled here.
  CRYPTO: {
    ASSETS: `payment/crypto/assets`,
    DEPOSIT: `payment/crypto/deposit`,
    WITHDRAW: `payment/crypto/withdraw`,
    VALIDATE_ADDRESS: `payment/crypto/validate-address`,
  },
  GAME: {
    HISTORY: `game/history`,
  },
  HISTORY: {
    GET_SESSIONS: `history/login`,
    ACTIVE_SESSIONS: `history/login/active`,
    REVOKE_SESSION: (id: string) => `history/login/active/${id}`,
  },
  NOTIFICATION: {
    GET: `notification`,
    UNREAD_COUNT: `notification/unread-count`,
    MARK_AS_READ: (notificationId: string) => `notification/${notificationId}/read`,
    MARK_ALL_AS_READ: `notification/read-all`,
    REMOVE: (notificationId: string) => `notification/${notificationId}`,
  },
  STATISTICS: {
    GET: (currency: string) => `statistics/${currency}`,
  },
  VIP: {
    LIST: `vip-list`,
    ME: `vip-list/me`,
  },
  JACKPOT: {
    LIST: `jackpot/list`,
  },
  HELP_CENTER: {
    HOME: `help-center`,
    SEARCH: `help-center/search`,
    ARTICLE: (slug: string) => `help-center/article/${encodeURIComponent(slug)}`,
    VOTE: (id: string) => `help-center/article/${encodeURIComponent(id)}/vote`,
  },
  SITE_PAGE: (slug: string) => `site-page/${encodeURIComponent(slug)}`,
  SUPPORT_WIDGET: {
    CONFIG: `support/widget`,
    IDENTITY: `support/widget/identity`,
  },
  DAILY_SPIN: {
    STATUS: `daily-spin/status`,
    SPIN: `daily-spin/spin`,
  },
  SLOT_BATTLE: {
    CONFIG: `slot-battle/config`,
    LOBBY: `slot-battle/lobby`,
    GAMES: `slot-battle/games`,
    MINE: `slot-battle/mine`,
    CREATE: `slot-battle/create`,
    JOIN: `slot-battle/join`,
    LEAVE: `slot-battle/leave`,
    CANCEL: `slot-battle/cancel`,
    BY_ID: (id: string) => `slot-battle/${id}`,
  },
  WAGER_RACE: {
    LIST: `wager-race`,
    WINNERS: `wager-race/winners`,
  },
  CHALLENGE: {
    LIST: `challenge`,
  },
  RAFFLE: {
    LIST: `raffle`,
    RESULTS: `raffle/results`,
    ENTRIES: (id: string) => `raffle/results/${id}/entries`,
  },
  VIP_BOOST: {
    GET: `vip-boost`,
    CLAIM: `vip-boost/claim`,
  },
  VIP_HOST: {
    GET: `vip-host`,
  },
  DAILY_CHECKIN: {
    ROOT: `daily-checkin`,
  },
  PLAYER_STATS: {
    PROFILE: `player-stats/profile`,
    SETTINGS: `player-stats/settings`,
  },
  RAKEBACK: {
    GET: `rakeback`,
    CLAIM: `rakeback/claim`,
    CLAIMS: `rakeback/claims`,
  },
  MISSION: {
    LIST: `mission`,
    CLAIM: (id: string) => `mission/${encodeURIComponent(id)}/claim`,
  },
  LOYALTY_STORE: {
    GET: `loyalty-store`,
    BUY: (id: string) => `loyalty-store/items/${encodeURIComponent(id)}/buy`,
    PURCHASES: `loyalty-store/purchases`,
    LEDGER: `loyalty-store/ledger`,
  },
  TIP: {
    CONFIG: `tip/config`,
    SEND: `tip`,
    RAIN: `tip/rain`,
    HISTORY: `tip/history`,
  },
  PROMOTION: {
    CAMPAIGNS: `promotion/campaigns`,
    MY_GRANTS: `promotion/my-grants`,
    MY_GRANTS_HISTORY: `promotion/my-grants/history`,
    FREE_SPINS: `promotion/free-spins`,
    REDEEM_CODE: `promotion/redeem-code`,
    ACTIVATE: (grantId: string) => `promotion/grants/${grantId}/activate`,
    CLAIM: (grantId: string) => `promotion/grants/${grantId}/claim`,
    SKY_CLAIM: `promotion/sky-claim`,
    CANCEL: (grantId: string) => `promotion/grants/${grantId}/cancel`,
  },
  LIVE_FEED: `live-feed`,
  SHARE: {
    SPORT: `share/sport`,
    CASINO: `share/casino`,
    GET: (code: string) => `share/${encodeURIComponent(code)}`,
  },
  REFERRAL: {
    ME: `referral/me`,
    STATS: `referral/stats`,
    RECENT: `referral/recent`,
  },
  TOURNAMENT: {
    LIST: `tournament/list`,
    JOIN: `tournament/join`,
    DETAIL: (tid: string) => `tournament/${tid}/detail`,
  },
  SPORT: {
    LIST: `sports/list`,
    EVENTS_BY_SPORT: `events/by-sport`,
    EVENTS_BY_REGION: `events/by-region`,
    EVENTS_BY_LEAGUE: `events/by-league`,
    SPORTS_TREE: `sports/tree`,
    LOBBY: `events/lobby`,
    EVENTS_BY_STATUS: `events/by-status`,
    EVENT_DETAIL: (eventId: string) => `events/${eventId}`,
    EVENT_LIVE: (eventId: string) => `events/${eventId}/live`,
    SEARCH: `events/search`,
    PLACE_BET: `sport/bets`,
    BET_HISTORY: `sport/bets`,
    BET_LIMITS: `sport/bets/limits`,
    CASHOUT_QUOTES: `sport/bets/cashout/quotes`,
    CASHOUT: (betId: string) => `sport/bets/${betId}/cashout`,
    AUTO_CASHOUT: (betId: string) => `sport/bets/${betId}/auto-cashout`,
    PROMOTIONS: `sport/bonuses`,
    FAVORITES: `sport/favorites`,
    FAVORITES_REMOVE: `sport/favorites/remove`,
  },
  CRASH: {
    STATE: `crash/state`,
    ME: `crash/me`,
    HISTORY: `crash/history`,
    VERIFY: (roundId: string) => `crash/verify/${roundId}`,
  },
  LIMBO: {
    STATE: `limbo/state`,
    PLAY: `limbo/play`,
    HISTORY: `limbo/history`,
    CLIENT_SEED: `limbo/client-seed`,
    ROTATE_SEED: `limbo/rotate-seed`,
    VERIFY: (betId: string) => `limbo/verify/${betId}`,
  },
  PLINKO: {
    STATE: `plinko/state`,
    PLAY: `plinko/play`,
    HISTORY: `plinko/history`,
    CLIENT_SEED: `plinko/client-seed`,
    ROTATE_SEED: `plinko/rotate-seed`,
    VERIFY: (betId: string) => `plinko/verify/${betId}`,
  },
  KENO: {
    STATE: `keno/state`,
    PLAY: `keno/play`,
    HISTORY: `keno/history`,
    CLIENT_SEED: `keno/client-seed`,
    ROTATE_SEED: `keno/rotate-seed`,
    VERIFY: (betId: string) => `keno/verify/${betId}`,
  },
  SLIDE: {
    STATE: `slide/state`,
    VERIFY: (roundId: string) => `slide/verify/${roundId}`,
  },
  MINES: {
    STATE: `mines/state`,
    START: `mines/start`,
    REVEAL: `mines/reveal`,
    CASHOUT: `mines/cashout`,
    HISTORY: `mines/history`,
    CLIENT_SEED: `mines/client-seed`,
    ROTATE_SEED: `mines/rotate-seed`,
    VERIFY: (gameId: string) => `mines/verify/${gameId}`,
  },
  COINFLIP: {
    STATE: `coinflip/state`,
    CREATE: `coinflip/create`,
    JOIN: `coinflip/join`,
    CANCEL: `coinflip/cancel`,
    HISTORY: `coinflip/history`,
    CLIENT_SEED: `coinflip/client-seed`,
    ROTATE_SEED: `coinflip/rotate-seed`,
    VERIFY: (gameId: string) => `coinflip/verify/${gameId}`,
  },
  DIAMONDS: {
    STATE: `diamonds/state`,
    PLAY: `diamonds/play`,
    HISTORY: `diamonds/history`,
    CLIENT_SEED: `diamonds/client-seed`,
    ROTATE_SEED: `diamonds/rotate-seed`,
    VERIFY: (betId: string) => `diamonds/verify/${betId}`,
  },
  ROULETTE: {
    STATE: `roulette/state`,
    SPIN: `roulette/spin`,
    HISTORY: `roulette/history`,
    CLIENT_SEED: `roulette/client-seed`,
    ROTATE_SEED: `roulette/rotate-seed`,
    VERIFY: (spinId: string) => `roulette/verify/${spinId}`,
  },
  BACCARAT: {
    STATE: `baccarat/state`,
    PLAY: `baccarat/play`,
    HISTORY: `baccarat/history`,
    CLIENT_SEED: `baccarat/client-seed`,
    ROTATE_SEED: `baccarat/rotate-seed`,
    VERIFY: (roundId: string) => `baccarat/verify/${roundId}`,
  },
  BACCARAT_TABLE: {
    STATE: `baccarat-table/state`,
    HISTORY: `baccarat-table/history`,
    VERIFY: (roundId: string) => `baccarat-table/verify/${roundId}`,
  },
  HILO: {
    STATE: `hilo/state`,
    START: `hilo/start`,
    CALL: `hilo/call`,
    CASH_OUT: `hilo/cash-out`,
    HISTORY: `hilo/history`,
    CLIENT_SEED: `hilo/client-seed`,
    ROTATE_SEED: `hilo/rotate-seed`,
    VERIFY: (runId: string) => `hilo/verify/${runId}`,
  },
  HILO_TABLE: {
    STATE: `hilo-table/state`,
    HISTORY: `hilo-table/history`,
    VERIFY: (roundId: string) => `hilo-table/verify/${roundId}`,
  },
  POKER: {
    STATE: `poker/state`,
    HISTORY: `poker/history`,
    CLIENT_SEED: `poker/client-seed`,
    VERIFY: (handId: string) => `poker/hand/${handId}`,
    CREATE_TABLE: `poker/tables`,
    TABLE_BY_CODE: (code: string) => `poker/tables/code/${code}`,
  },
  RUMMY: {
    STATE: `rummy/state`,
    HISTORY: `rummy/history`,
    CLIENT_SEED: `rummy/client-seed`,
    VERIFY: (dealId: string) => `rummy/deal/${dealId}`,
    CREATE_TABLE: `rummy/tables`,
    TABLE_BY_CODE: (code: string) => `rummy/tables/code/${code}`,
  },
  TRUCO: {
    STATE: `truco/state`,
    HISTORY: `truco/history`,
    CLIENT_SEED: `truco/client-seed`,
    VERIFY: (matchId: string, handNumber: number) => `truco/match/${matchId}/hand/${handNumber}`,
    CREATE_TABLE: `truco/tables`,
    TABLE_BY_CODE: (code: string) => `truco/tables/code/${code}`,
  },
  CHINCHON: {
    STATE: `chinchon/state`,
    HISTORY: `chinchon/history`,
    CLIENT_SEED: `chinchon/client-seed`,
    VERIFY: (matchId: string, roundNumber: number) =>
      `chinchon/match/${matchId}/round/${roundNumber}`,
    CREATE_TABLE: `chinchon/tables`,
    TABLE_BY_CODE: (code: string) => `chinchon/tables/code/${code}`,
  },
  TEEN_PATTI: {
    STATE: `teen-patti/state`,
    HISTORY: `teen-patti/history`,
    CLIENT_SEED: `teen-patti/client-seed`,
    VERIFY: (handId: string) => `teen-patti/hand/${handId}`,
    CREATE_TABLE: `teen-patti/tables`,
    TABLE_BY_CODE: (code: string) => `teen-patti/tables/code/${code}`,
  },
  ROCK_PAPER_SCISSORS: {
    STATE: `rock-paper-scissors/state`,
    CREATE: `rock-paper-scissors/create`,
    JOIN: `rock-paper-scissors/join`,
    CANCEL: `rock-paper-scissors/cancel`,
    HISTORY: `rock-paper-scissors/history`,
    CLIENT_SEED: `rock-paper-scissors/client-seed`,
    ROTATE_SEED: `rock-paper-scissors/rotate-seed`,
    VERIFY: (gameId: string) => `rock-paper-scissors/verify/${gameId}`,
  },
  RUSSIAN_ROULETTE: {
    STATE: `russian-roulette/state`,
    START: `russian-roulette/start`,
    PULL: `russian-roulette/pull`,
    CASHOUT: `russian-roulette/cashout`,
    HISTORY: `russian-roulette/history`,
    CLIENT_SEED: `russian-roulette/client-seed`,
    ROTATE_SEED: `russian-roulette/rotate-seed`,
    VERIFY: (gameId: string) => `russian-roulette/verify/${gameId}`,
  },
  DICE: {
    STATE: `dice/state`,
    PLAY: `dice/play`,
    HISTORY: `dice/history`,
    CLIENT_SEED: `dice/client-seed`,
    ROTATE_SEED: `dice/rotate-seed`,
    VERIFY: (betId: string) => `dice/verify/${betId}`,
  },
  DARTS: {
    STATE: `darts/state`,
    PLAY: `darts/play`,
    HISTORY: `darts/history`,
    CLIENT_SEED: `darts/client-seed`,
    ROTATE_SEED: `darts/rotate-seed`,
    VERIFY: (throwId: string) => `darts/verify/${throwId}`,
  },
  VIDEO_POKER: {
    STATE: `video-poker/state`,
    DEAL: `video-poker/deal`,
    DRAW: `video-poker/draw`,
    HINT: `video-poker/hint`,
    HISTORY: `video-poker/history`,
    CLIENT_SEED: `video-poker/client-seed`,
    ROTATE_SEED: `video-poker/rotate-seed`,
    VERIFY: (handId: string) => `video-poker/verify/${handId}`,
  },
  CHICKEN: {
    STATE: `chicken/state`,
    START: `chicken/start`,
    STEP: `chicken/step`,
    CASHOUT: `chicken/cashout`,
    HISTORY: `chicken/history`,
    CLIENT_SEED: `chicken/client-seed`,
    ROTATE_SEED: `chicken/rotate-seed`,
    VERIFY: (runId: string) => `chicken/verify/${runId}`,
  },
  GOAL: {
    STATE: `goal/state`,
    START: `goal/start`,
    KICK: `goal/kick`,
    CASHOUT: `goal/cashout`,
    HISTORY: `goal/history`,
    CLIENT_SEED: `goal/client-seed`,
    ROTATE_SEED: `goal/rotate-seed`,
    VERIFY: (runId: string) => `goal/verify/${runId}`,
  },
  SNAKES: {
    STATE: `snakes/state`,
    START: `snakes/start`,
    ROLL: `snakes/roll`,
    CASHOUT: `snakes/cashout`,
    HISTORY: `snakes/history`,
    CLIENT_SEED: `snakes/client-seed`,
    ROTATE_SEED: `snakes/rotate-seed`,
    VERIFY: (runId: string) => `snakes/verify/${runId}`,
  },
  WHEEL: {
    STATE: `wheel/state`,
    VERIFY: (roundId: string) => `wheel/verify/${roundId}`,
  },
  BLACKJACK: {
    STATE: `blackjack/state`,
    DEAL: `blackjack/deal`,
    ACTION: `blackjack/action`,
    HISTORY: `blackjack/history`,
    CLIENT_SEED: `blackjack/client-seed`,
    ROTATE_SEED: `blackjack/rotate-seed`,
    VERIFY: (roundId: string) => `blackjack/verify/${roundId}`,
  },
  FLOWER_POKER: {
    STATE: `flower-poker/state`,
    PLAY: `flower-poker/play`,
    HISTORY: `flower-poker/history`,
    CLIENT_SEED: `flower-poker/client-seed`,
    ROTATE_SEED: `flower-poker/rotate-seed`,
    VERIFY: (gameId: string) => `flower-poker/verify/${gameId}`,
  },
};
